import dayjs from 'dayjs'
import {Dancer} from 'models'
import {Group} from 'models/dancer'
import {$, k} from '../i18n/localization'

const DATE_PRIX_2026 = '2026-02-07' // fallback date

export const getAge = (dancer: Dancer, short?: boolean) => {
  // Priority: use pre-calculated age from DB
  if (dancer.Age_during_finals) {
    if (short) {
      // Convert "17 years, 10 month" -> "17.10"
      const match = dancer.Age_during_finals.match(/(\d+)\s*years?,\s*(\d+)\s*months?/)
      if (match) return `${match[1]}.${match[2]}`
    }
    return dancer.Age_during_finals
  }

  // Fallback: calculate from Birthdate
  const ageDate = dayjs(DATE_PRIX_2026)
  const birthDate = dayjs(dancer.Birthdate)
  const years = ageDate.diff(birthDate, 'year')
  const months = ageDate.diff(birthDate.add(years, 'year'), 'month')

  if (short) return `${years}.${months}`
  return `${years} year${years !== 1 ? 's' : ''}, ${months} month${months !== 1 ? 's' : ''}`
}

export const getSeniority = (dancer: Dancer) => {
  if (dancer.Group) {
    if ([Group.GirlsA, Group.BoysA].includes(dancer.Group)) return $(k.junior)
    if ([Group.GirlsB, Group.BoysB].includes(dancer.Group)) return $(k.senior)
  }
  return '-'
}
